var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"groove-builder-tabs",attrs:{"aria-label":_vm.config.title + ' versions'}},[_c('router-link',{class:{selected: !_vm.legacy},attrs:{"to":_vm.config.path}},[_vm._v(_vm._s(_vm.config.title))]),_c('router-link',{class:{selected: _vm.legacy},attrs:{"to":_vm.config.legacy}},[_vm._v(_vm._s(_vm.config.legacyTitle))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }